import script from "./PartCollectionBlock.vue?vue&type=script&setup=true&lang=ts"
export * from "./PartCollectionBlock.vue?vue&type=script&setup=true&lang=ts"

import "./PartCollectionBlock.vue?vue&type=style&index=0&id=70a9a71b&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70a9a71b"]])

export default __exports__